import * as React from 'react';
import PropTypes from 'prop-types';
import LocalPhoneIcon from '@mui/icons-material/LocalPhone';
import PublicIcon from '@mui/icons-material/Public';
import EmailIcon from '@mui/icons-material/Email';
import ChatBubbleIcon from '@mui/icons-material/ChatBubble';

import { ContactContainers, StyledSpan, StyledLink } from './styles';

export const Contacts = (props) => {
  const { contacts } = props;

  return (
    <>
      {contacts.map((contact, index) => {
        if (contact.type === 'Phone') {
          return (
            <ContactContainers key={index}>
              <LocalPhoneIcon className="fas fa-phone-square-alt" />
              <StyledSpan>
                {contact.name + ': '}
                <StyledLink href={`tel:${contact.value}`}>{contact.value}</StyledLink>
              </StyledSpan>
            </ContactContainers>
          );
        } else if (contact.type === 'Website') {
          return (
            <ContactContainers key={index}>
              <PublicIcon className="fas fa-globe-americas" />
              <StyledSpan>
                {contact.name + ': '}
                <StyledLink href={`${contact.value}`}>{contact.value}</StyledLink>
              </StyledSpan>
            </ContactContainers>
          );
        } else if (contact.type === 'Email') {
          return (
            <ContactContainers key={index}>
              <EmailIcon className="fas fa-envelope" />
              <StyledSpan>
                {contact.name + ': '}
                <StyledLink href={`mailto:${contact.value}`}>{contact.value}</StyledLink>
              </StyledSpan>
            </ContactContainers>
          );
        } else if (contact.type === 'Text') {
          return (
            <ContactContainers key={index}>
              <ChatBubbleIcon className="fas fa-scroll" />
              <StyledSpan>
                {contact.name + ': '}
                <StyledDiv>{contact.value}</StyledDiv>
              </StyledSpan>
            </ContactContainers>
          );
        }
      })}
    </>
  );
};

Contacts.propTypes = {
  contacts: PropTypes.any,
};

export default Contacts;
